import { useMemo } from 'react';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useServerEvents } from '#lib/useServerEvents';

import { fetchAIAnalyses } from '../../api/companyAnalysisApi';

import { companyAnalysisKeys } from './keys';

export const useAIAnalysesWithRealtime = (companyIds, prospectQueryId, isAnalysisRunning = false) => {
	const queryClient = useQueryClient();
	const query = useQuery({
		queryKey: companyAnalysisKeys.analysis(prospectQueryId, companyIds),
		queryFn: () => fetchAIAnalyses(companyIds, prospectQueryId),
		enabled: Boolean(prospectQueryId && companyIds && companyIds.length > 0),
	});

	const topics = useMemo(
		() => (prospectQueryId && isAnalysisRunning ? [`analyses:${prospectQueryId}`] : []),
		[prospectQueryId, isAnalysisRunning],
	);

	useServerEvents(topics, {
		enabled: isAnalysisRunning && Boolean(prospectQueryId),
		onEvent: (eventType, data) => {
			if (!companyIds?.includes(data.globalCompanyId)) return;

			const queryKey = companyAnalysisKeys.analysis(prospectQueryId, companyIds);

			queryClient.setQueryData(queryKey, (oldData) => {
				if (!oldData) return [data];

				const existingIndex = oldData.findIndex((a) => a.globalCompanyId === data.globalCompanyId);

				if (existingIndex >= 0) {
					const newData = [...oldData];
					newData[existingIndex] = { ...newData[existingIndex], ...data };
					return newData;
				}

				return [...oldData, data];
			});
		},
	});

	return query;
};
